<template>
  <el-table-column
    prop="user.last_name"
    label="Területi képviselő(k)"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      <p
        v-for="user in scope.row.representative_users"
        :key="user.id"
        style="margin: 0; line-height: 1.5;"
      >
        {{ user.last_name }} {{ user.first_name }}
      </p>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'user.last_name',
  };
</script>
